import { createInterpolatedTranslationKey, createTranslatedText, TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { HealthcareProviderLocation } from '~libs.shared.healthcare-provider-location';

import { translationKeys } from '../../../translations';
import { WaitlistFilterPanelSearchParam } from '../../WaitlistFilterPanel.types';

export const createHealthcareProviderLocationsTriggerLabelExtractor = (
   totalCount: number,
   translate: TranslateFunction
): ((chosenHealthcareProviderLocations: HealthcareProviderLocation[]) => string) => {
   return (chosenHealthcareProviderLocations) => {
      if (chosenHealthcareProviderLocations.length === 1) {
         return chosenHealthcareProviderLocations.at(0)!.name;
      }
      const translationKey = createInterpolatedTranslationKey(translationKeys.chosenOptions, {
         count: chosenHealthcareProviderLocations.length,
         totalCount: totalCount,
      });
      return translate(translationKey);
   };
};

export const createHealthcareProviderLocationsCodec = (
   locations: HealthcareProviderLocation[]
): FilterPanelControllerCodecConfigArray<HealthcareProviderLocation> => ({
   type: 'array',
   items: locations,
   keyGenerator: (location) => location.id.asString(),
   mode: 'string',
});

export const healthcareProviderLocationsDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   HealthcareProviderLocation[],
   WaitlistFilterPanelSearchParam.HEALTHCARE_PROVIDER_LOCATION
> = (currentLocations) => {
   return currentLocations.map((location) => ({
      targetValue: currentLocations.filter((currentLocation) => currentLocation.id !== location.id),
      label: createTranslatedText(location.name),
      testId: `location-${location.id}`,
   }));
};
